// Human labels for Bitmovin dimension values (languages, devices, unknowns).

const LANGUAGE_FALLBACK = {
	en: 'English', es: 'Spanish', fr: 'French', de: 'German', it: 'Italian', pt: 'Portuguese',
	ru: 'Russian', zh: 'Chinese', ja: 'Japanese', ko: 'Korean', ar: 'Arabic', hi: 'Hindi',
	nl: 'Dutch', sv: 'Swedish', pl: 'Polish', tr: 'Turkish', uk: 'Ukrainian', vi: 'Vietnamese',
	th: 'Thai', id: 'Indonesian', he: 'Hebrew', el: 'Greek', cs: 'Czech', da: 'Danish',
	fi: 'Finnish', no: 'Norwegian', hu: 'Hungarian', ro: 'Romanian', ms: 'Malay', tl: 'Filipino',
};

let displayNames = null;
let displayNamesChecked = false;

function getDisplayNames() {
	if (displayNamesChecked) return displayNames;
	displayNamesChecked = true;
	try {
		if (typeof Intl.DisplayNames === 'function') {
			displayNames = new Intl.DisplayNames(['en'], { type: 'language', fallback: 'none' });
		}
	} catch (e) {
		displayNames = null;
	}
	return displayNames;
}

export const UNKNOWN_VALUES = new Set(['', '?', 'null', 'undefined', 'unknown', 'n/a', 'none', '-']);

export function isUnknownValue(value) {
	if (value === null || value === undefined) return true;
	return UNKNOWN_VALUES.has(String(value).trim().toLowerCase());
}

/**
 * "en-US" -> "English (US)", "pt" -> "Portuguese", "xx" -> "xx".
 * `emptyLabel` is used for null/unknown (e.g. captions "Off").
 */
export function formatLanguage(code, emptyLabel = 'Unknown') {
	if (isUnknownValue(code)) return emptyLabel;
	const raw = String(code).trim();
	const normalized = raw.replace('_', '-');
	const [base, region] = normalized.split('-');
	const baseLower = base.toLowerCase();
	let name = null;
	const dn = getDisplayNames();
	if (dn) {
		try {
			name = dn.of(normalized) || dn.of(baseLower) || null;
		} catch (e) {
			name = null;
		}
	}
	if (!name) {
		const fallback = LANGUAGE_FALLBACK[baseLower];
		if (!fallback) return raw;
		name = region ? `${fallback} (${region.toUpperCase()})` : fallback;
	}
	return name;
}

const DEVICE_CLASS_LABELS = {
	desktop: 'Desktop',
	phone: 'Phone',
	mobile: 'Phone',
	tablet: 'Tablet',
	tv: 'TV',
	console: 'Console',
	wearable: 'Wearable',
	other: 'Other',
};

export function formatDeviceClass(value) {
	if (isUnknownValue(value)) return 'Unknown';
	const key = String(value).trim().toLowerCase();
	return DEVICE_CLASS_LABELS[key] || String(value);
}

/**
 * Generic dimension label (browser, OS, region): keep the API value, but map
 * unknown markers to a readable placeholder.
 */
export function formatDimensionValue(value, unknownLabel = 'Unknown') {
	if (isUnknownValue(value)) return unknownLabel;
	return String(value);
}
